export const Admin = {
	//免密登录
	getMMDL:'api/Account/LoginGuid',
	AddExpertFromClanEmail:'api/Clan/AddExpertFromClanEmail',
	//高级检索栏目领域是否显示
	getSFXS:'api/Common/GetSetItem',
	//首页调用系统设置
	getSet:'api/Common/GETSetItems',
	//头部导航栏
	getHeader:'api/Document/GetFixedItemBodys',
	//获取网站访问量
	getAllSum:'api/baiduapi/GetAllSum',
	//首页广告
	GetFloatingAds:'api/AdFloat/GetFloatingAds',
	//文章浏览次数s
	getLLCS:'api/Web/IncView_Times',
	//文档浏览次数
	getWZCS:'api/Document/Hits',
	//下载次数
	getXZCS:'api/Web/IncArticleRead_Times',
	//首页轮播接口
	getBanner:'api/Common/GetLoopItem',
	//获取期数据接口
	getYear: 'api/Web/GetIssue',
	//获取最新一期的Rss
	GetRss: 'api/Web/GetRss',
	//基于OA预出版的Rss
	GetRssycb:'api/Web/GetRssycb',
	//基于稿件预出版RSS
	GetscriptRssycb:'api/Web/GetscriptRssycb',
	//获取导出接口
	getDC:'api/Web/GetIssue',
	//获取首页列表预出版接口
	getList:'api/Common/GetSetItem',
	getLista:'api/Web/PreprintList',
	getListb: 'api/Web/OAList',
	//下载/阅读统计
	getOAViewTJ:"api/web/YearStatistics",
	//预出版详情
	GetScriptPrePrintDetailed:'api/Web/GetScriptPrePrintDetailed',
	//获取首页列表最新一期接口
	getNewlist:'api/Web/LastIssueList',
	//过刊目录列表接口
	getgok:'api/Web/GetCatalog',
	//高级检索学科领域接口
	getXKLX:'api/Common/GetDictList',
	//下载PDF接口
	getPDF: 'api/Web/ArticleDownLoad',
	//下载PDF接口new
	getPDFnew: 'api/Web/ArticleCanDownLoadNew',
	getPDFfile: 'api/Web/OpenArticleFilebyGuidNew',
	//高级检索栏目接口
	getLM: 'api/Common/GetOAColumnDictList',
	//html次数
	getHtmlRead:'api/Web/HtmlRead_Times',
	//投稿须知
	getTGXZ: 'api/Document/GetFixedItemBodys',
	//期封面、封底、目次下载接口
	IssueDownLoad: 'api/Web/IssueDownLoad',
	//期数据接口
	getQSJ: 'api/Web/GetIssue',
	//首页封面，封底，目次打开文件
	OpenGUIDFile: 'api/Common/OpenGUIDFile',
	OpenFilebyGuid:"api/Common/OpenFilebyGuid",
  OpenMessageFilebyGuid:"api/Common/OpenMessageFilebyGuid",
	//导出接口
	getDCJK: 'api/Web/ExportFormat',
	//首页总访问数
	getFWZS: 'api/PageVisit/GetVisitCount',
	//文章导出接口
	getWZDC: 'api/Web/ExportList',
	//下载排行接口
	getXZPH: 'api/Web/OAList',
	//列表详情接口
	getLBXQ: 'api/Web/GetArticleDetailed',
	//作者园地接口
	getActor:'api/Document/GetDocumentList',//post,
	//期刊社公告接口
	getTELL:'api/Document/GetDocumentList',//post
	//文章检索接口
	postSearch:'api/Web/ArticleSearch',//post
	//发表评论接口
	postMassage:'api/Comments/Item',//post
	//评论列表接口
	getPLLB:'api/Comments/GetCommentList',//post
	getdownXML:'api/Web/GetXML',
	//友情链接接口
	postFirend:'api/Links/GetLinks',//post
	//作者园地/期刊社动态详情
	getdetailes: 'api/Document/GetDetailed',
	//年度区间接口
	postNDCJ: 'api/common/GetPublishYearList',
	// //bai
	//发送验证码
	getRegSendCode: 'api/CRCActiveRecord/Verificationcode',
	//验证用户邮箱手机号是否已注册
	getRegDeteCt:'api/Account/IsRegistered',
	//注册
	postRegist:'api/Account/Register',//post
	postThirdRegister:'api/Account/ThirdRegister',//post
	//登录
	postLogin:'api/Account/Login',//post
	//页面初始化形成验证码以及GUID
	getVerificationcodeImg:'api/Account/VerificationcodeImg', //post
	//忘记密码
	getForgetPassword :'api/Account/ForgetPassword', //post
	//找回密码页面添加相同邮箱和手机号所有账号列表
	getIsRegistered:'api/Account/IsRegistered', //get
	getReSetPassword:'api/CRCActiveRecord/ReSetPassword', //get
	ForgetPasswordByGuid:'api/Account/ForgetPasswordByGuid',
	getForgetPasswordGroup :'api/Account/ForgetPasswordGroup', //post
	aaaa : 'api/Document/GetDetailed',
    //weixin登录
    getGetQrcode :'api/WeiXin/GetQrcode', //get
	getWeiXinLogin :'api/Account/WeiXinLogin', //get
	
	GetToken:'api/weixin/GetToken',
	EamilVerification:"api/Account/EamilVerification",
	NoLoginChangePassword:"api/Account/NoLoginChangePassword",
	GetYearIssueList:"api/Web/GetYearIssueList",
	GetArticleIDByNum:'api/Web/GetArticleIDByNum',
	PostSubscribe:'api/Common/PostSubscribe',
	UnSubscribe:'api/Common/UnSubscribe',
	GetIssueList:'api/Common/GetIssueList',
	GetRouter:"api/SystemCommon/GetRouter",
	PostScriptZT:'api/Account/PostScriptZT',
	ClanLoginChangePassword:"api/Account/ClanLoginChangePassword",
	ClanUserLogin:"api/Account/ClanUserLogin",
};
